module.exports = __webpack_public_path__ + "static/media/LenaSlide.8e115010.jpg";